/**
 * Darf der Serienversand starten? Der Nutzer muss die Empfaengerzahl abtippen —
 * ein Rundschreiben laesst sich nicht zurueckholen, und der Knopf sitzt neben
 * „Testmail senden".
 *
 * Reihenfolge der Pruefungen ist Absicht: erst die inhaltlichen Maengel melden,
 * die Zahl zuletzt. Sonst tippt jemand die Zahl ab und erfaehrt DANN, dass der
 * Betreff fehlt.
 */
export function darfStarten(eingabe: string, anzahl: number, betreff: string): { erlaubt: boolean; grund: string | null } {
  if (anzahl <= 0) return { erlaubt: false, grund: 'Kein Empfänger ausgewählt.' };
  if (!betreff.trim()) return { erlaubt: false, grund: 'Bitte einen Betreff angeben.' };
  if ((eingabe || '').trim() !== String(anzahl)) {
    return { erlaubt: false, grund: `Bitte zur Bestätigung die Empfängerzahl ${anzahl} eintragen.` };
  }
  return { erlaubt: true, grund: null };
}
